import { useMemo } from 'react';
import { useParams } from 'react-router';
import { Alert, Card } from 'antd';
import { useQuery } from '@apollo/client/react';

import QueryBoundary from 'components/QueryBoundary/QueryBoundary';
import FundingAccountTable from 'components/FundingAccountTable/FundingAccountTable';
import { CUSTOMER_FUNDING_ACCOUNTS } from 'queries/fundingAccounts';
import useAccountsInfo from 'hooks/useAccountsInfo';

const FundingAccountsPage = () => {
  const { customerId } = useParams();
  const { allAccountsInDebtSale } = useAccountsInfo();

  const accountsQuery = useQuery(CUSTOMER_FUNDING_ACCOUNTS, {
    notifyOnNetworkStatusChange: true,
    variables: { customerId },
  });

  const fundingAccounts = useMemo(() => {
    return accountsQuery.data?.fundingAccounts || [];
  }, [accountsQuery.data]);

  return (
    <Card title="Funding Accounts">
      {allAccountsInDebtSale && (
        <Alert
          banner
          title="Unable to add new funding accounts for this customer because all of their accounts are in debt sale"
          type="error"
          style={{ marginBottom: 'var(--spacing-sm)' }}
          data-testid="debt-sale-alert"
        />
      )}
      <QueryBoundary
        query={accountsQuery}
        mode={QueryBoundary.MODE.MESSAGE}
        loadingMessage="Retrieving Funding Accounts"
      >
        <FundingAccountTable
          fundingAccounts={fundingAccounts}
          canAddFundingAccount={!allAccountsInDebtSale}
          loading={accountsQuery.loading}
        />
      </QueryBoundary>
    </Card>
  );
};

export default FundingAccountsPage;
